import { render } from "./VocationalCultivatingNewConnections.vue?vue&type=template&id=00fa2ae2&scoped=true"
import script from "./VocationalCultivatingNewConnections.vue?vue&type=script&lang=js"
export * from "./VocationalCultivatingNewConnections.vue?vue&type=script&lang=js"

import "./VocationalCultivatingNewConnections.vue?vue&type=style&index=0&id=00fa2ae2&lang=sass&scoped=true"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00fa2ae2"]])

export default __exports__